import BossModel from "@/models/BossModel";

export default class AvailableDate extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/available-date';

    /**
     *
     * @type {string}
     */
    static entity = 'availableDates';

    static fields() {
		return {
			id: this.number(null).nullable(),
			product_id: this.number(null).nullable(),
			date: this.attr(null),
		}
	}
}
